import { render, staticRenderFns } from "./PartnerHeader.vue?vue&type=template&id=68e20736&scoped=true&"
import script from "./PartnerHeader.vue?vue&type=script&lang=js&"
export * from "./PartnerHeader.vue?vue&type=script&lang=js&"
import style0 from "./PartnerHeader.vue?vue&type=style&index=0&id=68e20736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e20736",
  null
  
)

export default component.exports